import React from "react";
import AnimationContainer from "../../../Reusable/AnimationContainer/AnimationContainer.js";
import { AnimatedProgressCircle } from "../../../Elements/AnimatedProgressCircle/AnimatedProgressCircle.js";
import Icon from "components/Elements/Icon/Icon.tsx";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  title: string;
  message: string;
  icon: string;
}

export const ExternalNotification: React.FC<Props> = ({
  show,
  setShow,
  title,
  message,
  icon,
}) => {
  return (
    <AnimationContainer animationOn={show} animationClassName="fade-in">
      <div
        className="external-noti-container"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="top-section">
          <span>{title}</span>
          <div className="close-toast-section" onClick={(e) => setShow(false)}>
            <Icon name="x" lightgray />
          </div>
        </div>
        <div className="bottom-section">
          <Icon name={icon} darkGray />
          <span>{message}</span>
          <div className="flex-spacer" />
          <AnimatedProgressCircle
            containerSize="40"
            color={"#15B4D4"}
            circfleRadius={10}
          />
        </div>
      </div>
    </AnimationContainer>
  );
};
